import { combineReducers } from '@reduxjs/toolkit'
import { vbAuthApi } from './vbAuthApi'
import { staffApi } from './staffApi'
import { authApi } from './authApi'
import { clientsApi } from './clientsApi'
import { adminActivityApi } from './adminActivityApi'
import { dashboardApi } from './dashboardApi'
import { appConfigsApi } from './appConfigsApi'
import { roleApi } from './roleApi'
import { productivityApi } from './productivityApi'
import { attendanceApi } from './attendanceApi'
import { clientPortalApi } from './clientPortalApi'
import { servicesApi } from './servicesApi'
import { invoiceApi } from './invoiceApi'
import { tasksApi } from './tasksApi'
import { projectApi } from './projectApi'
import { scheduleApi } from './scheduleApi'
import { feedbackApi } from './feedbackApi'
import { auditLogsApi } from './auditLogsApi'
import { clientInvoicesApi } from './clientInvoicesApi'
import { serviceRequestApi } from './service-requestApi'
import { adminAnalyticsApi } from './adminAnalyticsApi'
import { clientTicketApi } from './clientTicketApi'
import { adminTicketApi } from './adminTicketApi'
import { complianceApi } from './complianceApi'
import { operationManagerApi } from './operationMangerApi'
import { teamLeaderApi } from './teamLeaderApi'
import { siteManagementApi } from './siteManagmentApi'
import { safetyApi } from './safetyApi'
import { magicLinkApi } from './magic-linkApi'
import { agentApi } from './agentApi'
import { taskAssignmentApi } from './taskAssignmentApi'
import { chatbotApi } from './chatbotApi'
import { weatherApi } from './weatherApi'
import { businessProjectApi } from './businessProjectApi'
import { oshaApi } from './oshaApi'
import { businessOnboardingApi } from './businessOnboardingApi'
import { businessStorageApi } from './businessStorageApi'
import { businessMessagingApi } from './businessMessagingApi'
import { ticketApi } from './ticketApi'
import { saasNotificationApi } from './saasNotificationApi'
import { businessSkillsApi } from './businessSkillsApi'
import { businessGeneralApi } from './businessGeneralApi'
import { locationApi } from './locationApi'
import { teamLocationApi } from './teamLocationApi'
import { serviceAreaApi } from './serviceAreaApi'
import { routeOptimizationApi } from './routeOptimizationApi'
import { routeAnalyticsApi } from './routeAnalyticsApi'
import { fieldTaskApi } from './fieldTaskApi'
import { weatherRouteApi } from './weatherRouteApi'
import { businessActivitiesApi } from './businessActivitiesApi'
import { qualityInspectionApi } from './qualityInspectionApi'
import { checkInConfigApi } from './checkInConfigApi'

const rootReducer = combineReducers({
  [vbAuthApi.reducerPath]: vbAuthApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [staffApi.reducerPath]: staffApi.reducer,
  [clientsApi.reducerPath]: clientsApi.reducer,
  [adminActivityApi.reducerPath]: adminActivityApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [appConfigsApi.reducerPath]: appConfigsApi.reducer,
  [roleApi.reducerPath]: roleApi.reducer,
  [productivityApi.reducerPath]: productivityApi.reducer,
  [attendanceApi.reducerPath]: attendanceApi.reducer,
  [clientPortalApi.reducerPath]: clientPortalApi.reducer,
  [servicesApi.reducerPath]: servicesApi.reducer,
  [invoiceApi.reducerPath]: invoiceApi.reducer,
  [tasksApi.reducerPath]: tasksApi.reducer,
  [projectApi.reducerPath]: projectApi.reducer,
  [scheduleApi.reducerPath]: scheduleApi.reducer,
  [feedbackApi.reducerPath]: feedbackApi.reducer,
  [serviceRequestApi.reducerPath]: serviceRequestApi.reducer,
  [auditLogsApi.reducerPath]: auditLogsApi.reducer,
  [clientInvoicesApi.reducerPath]: clientInvoicesApi.reducer,
  [adminAnalyticsApi.reducerPath]: adminAnalyticsApi.reducer,
  [clientTicketApi.reducerPath]: clientTicketApi.reducer,
  [adminTicketApi.reducerPath]: adminTicketApi.reducer,
  [complianceApi.reducerPath]: complianceApi.reducer,
  [operationManagerApi.reducerPath]: operationManagerApi.reducer,
  [teamLeaderApi.reducerPath]: teamLeaderApi.reducer,
  [siteManagementApi.reducerPath]: siteManagementApi.reducer,
  [safetyApi.reducerPath]: safetyApi.reducer,
  [magicLinkApi.reducerPath]: magicLinkApi.reducer,
  [agentApi.reducerPath]: agentApi.reducer,
  [taskAssignmentApi.reducerPath]: taskAssignmentApi.reducer,
  [chatbotApi.reducerPath]: chatbotApi.reducer,
  [weatherApi.reducerPath]: weatherApi.reducer,
  [businessProjectApi.reducerPath]: businessProjectApi.reducer,
  [oshaApi.reducerPath]: oshaApi.reducer,
  [businessOnboardingApi.reducerPath]: businessOnboardingApi.reducer,
  [businessStorageApi.reducerPath]: businessStorageApi.reducer,
  [businessMessagingApi.reducerPath]: businessMessagingApi.reducer,
  [ticketApi.reducerPath]: ticketApi.reducer,
  [saasNotificationApi.reducerPath]: saasNotificationApi.reducer,
  [businessSkillsApi.reducerPath]: businessSkillsApi.reducer,
  [businessGeneralApi.reducerPath]: businessGeneralApi.reducer,
  [locationApi.reducerPath]: locationApi.reducer,
  [teamLocationApi.reducerPath]: teamLocationApi.reducer,
  [serviceAreaApi.reducerPath]: serviceAreaApi.reducer,
  [routeOptimizationApi.reducerPath]: routeOptimizationApi.reducer,
  [routeAnalyticsApi.reducerPath]: routeAnalyticsApi.reducer,
  [fieldTaskApi.reducerPath]: fieldTaskApi.reducer,
  [weatherRouteApi.reducerPath]: weatherRouteApi.reducer,
  [businessActivitiesApi.reducerPath]: businessActivitiesApi.reducer,
  [qualityInspectionApi.reducerPath]: qualityInspectionApi.reducer,
  [checkInConfigApi.reducerPath]: checkInConfigApi.reducer
  
})

export default rootReducer
